import { META_EVENTS } from 'config/metaConfig';
import { isMetaPixelInitialized } from 'consent/initMetaPixel';

type MetaPixelParams = Record<string, string | number | boolean | undefined>;

type FbqWindow = Window & {
  fbq?: (...args: unknown[]) => void;
};

const trackMetaPixelEvent = (eventName: string, params?: MetaPixelParams): void => {
  if (!isMetaPixelInitialized() || typeof window === 'undefined') {
    return;
  }

  const { fbq } = window as FbqWindow;
  if (!fbq) {
    return;
  }

  if (!params) {
    fbq('track', eventName);
    return;
  }

  const cleanedParams = Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== undefined)
  );

  fbq('track', eventName, cleanedParams);
};

export type MetaCompleteRegistrationParams = {
  registerMethod?: string;
};

/** Web signup conversion. */
export const trackMetaCompleteRegistration = (params?: MetaCompleteRegistrationParams): void => {
  trackMetaPixelEvent(META_EVENTS.completeRegistration, {
    status: 'completed',
    content_name: params?.registerMethod,
  });
};

export type MetaSubscribeParams = {
  value?: number;
  currency?: string;
  contentName?: string;
  contentIds?: string;
  /** e.g. YEARLY / MONTHLY */
  subscriptionType?: string;
  eventId?: string;
};

/** Fires on completed Stripe subscription only. */
export const trackMetaSubscribe = (params?: MetaSubscribeParams): void => {
  trackMetaPixelEvent(META_EVENTS.subscribe, {
    value: params?.value,
    currency: params?.currency ?? 'EUR',
    content_name: params?.contentName,
    content_ids: params?.contentIds,
    content_category: params?.subscriptionType,
    eventID: params?.eventId,
  });
};
